import React, { useState, useEffect } from "react";
import { getPlanesActivos } from "../../services/Planes";
import { getRegistroPlanesId } from "../../services/RegistroPlanes";
import formatCurrency from "../../formatters/currency";

const CardPlanesServicios = ({ onSelectionChange }) => {
  const [planes, setPlanes] = useState([]);
  const [seleccionados, setSeleccionados] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const todosLosPlanes = await getPlanesActivos();
      const planesMarcados = await getRegistroPlanesId();

      // Extraer los _id reales de los planes desde los registros previos
      const idsMarcados = (planesMarcados || []).map((p) => p.idPlan);

      setPlanes(todosLosPlanes || []);
      setSeleccionados(idsMarcados);
      onSelectionChange(idsMarcados); // Enviar a componente padre si es necesario
    };
    fetchData();
  }, []);

  const toggleSeleccion = (planId) => {
    const yaSeleccionado = seleccionados.includes(planId);
    const nuevaSeleccion = yaSeleccionado
      ? seleccionados.filter((id) => id !== planId)
      : [...seleccionados, planId];

    setSeleccionados(nuevaSeleccion);
    onSelectionChange(nuevaSeleccion);
  };

  const renderGrupo = (titulo, planesGrupo) => (
    <div className="mb-6">
      <h2 className="text-lg font-semibold text-gray-700 mb-3">{titulo}</h2>
      <div className="flex flex-col gap-4">
        {planesGrupo.map((plan) => {
          const estaSeleccionado = seleccionados.includes(plan._id);
          return (
            <div
              key={plan._id}
              className={`flex items-center justify-between p-4 rounded-lg border shadow-sm transition-all ${
                estaSeleccionado ? "bg-green-100 border-green-500" : "bg-white"
              }`}
            >
              <label className="flex items-start gap-3 cursor-pointer w-full">
                <input
                  type="checkbox"
                  checked={estaSeleccionado}
                  onChange={() => toggleSeleccion(plan._id)}
                  className="mt-1"
                />
                <div>
                  <h3 className="font-bold text-gray-800">{plan.nombrePlan}</h3>
                  <p className="text-sm text-gray-600">{plan.descripcion}</p>
                  <p className="text-sm text-indigo-600 font-semibold mt-1">
                    {formatCurrency(plan.valor)}
                  </p>
                </div>
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );

  const planesRetiro = planes.filter((p) => p.tipoPlan === "Retiro");
  const planesDropoff = planes.filter((p) => p.tipoPlan !== "Retiro");

  return (
    <>
      {renderGrupo("Retiro en Domicilio", planesRetiro)}
      {renderGrupo("Entrega en Punto Drop Off", planesDropoff)}
    </>
  );
};

export default CardPlanesServicios;
